import { render, staticRenderFns } from "./viewwmarks.vue?vue&type=template&id=6cc5ad0c&"
import script from "./viewwmarks.vue?vue&type=script&lang=js&"
export * from "./viewwmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports